import { CmsProtectionDetailsApplianceCarePanelHeader } from '../../models/protection-details/cms-protection-details-appliance-care-panel-header.interface';

export const mockCmsProtectionDetailsApplianceCarePanelHeader: CmsProtectionDetailsApplianceCarePanelHeader =
  {
    protectionDetailsApplianceCarePanelHeaderSubtitle:
      'protectionDetailsHeaderSubtitle',
    protectionDetailsApplianceCarePanelHeaderTitle:
      'protectionDetailsHeaderTitle',
  };
